import * as React from "react";
import {UIState} from "data/UIState";
import {observer} from "mobx-react";
import {ButtonAction} from "../widgets/ButtonAction";

@observer
export default class Step4Fitbit extends React.Component<Props> {
  render() {
    return (
     <>
         <div className="fitbitPanel">
           <div className="col1">
             <img src="/res_sys/fitbit_teaser.png"/>
           </div>
           <div className="col2">
             <h2>Have a fitbit?</h2>
             <p>Sync your daily metrics to the portal.</p>
             <a href={UIState.settings.FITBIT_AUTH_URL}>Add Fitbit &rarr;</a>
             <p className="mini">The Portal will only pull data, and won’t send any back</p>
           </div>
         </div>
         <div className="underFitbitPanel">
           <h2>Don’t have a Fitbit?</h2>
           <p>No worries, the portal lets you enter daily metrics like Steps, Activity, Sleep and Water</p>
         </div>
         <div className={'form-element tight'}>
           {/*<ButtonAction onClick={this.props.continue} className={"cta-button noselect"}>Continue to the Dashboard</ButtonAction>*/}
           <a className="cta-button noselect" onClick={this.props.continue} href="#">Continue to the Dashboard</a>
         </div>
       </>
    );
  }
}

interface Props {
  continue:()=>void;
}
